import { LabFileBrowser } from '../components/lab-file-browser';
import { FileBrowserSelectionType } from '@convergence/types';
import { useStateLocalStorageAndUrl } from '../hooks/useStateLocalStorageAndUrl';

export function Files() {
  const [fileBrowserState, setFileBrowserState] = useStateLocalStorageAndUrl(
    'fileBrowser',
    {
      bucketId: null as number | null,
      path: [] as string[]
    },
    {
      path: (v) => {
        return v.length === 0 ? null : v.join('/');
      },
      bucketId: (v) => {
        return v === null ? '' : v.toString();
      }
    },
    {
      path: (v) => {
        return v.split('/').filter((p) => p.length > 0);
      },
      bucketId: (v) => {
        const n = Number(v);
        return isNaN(n) ? null : n;
      }
    }
  );

  return (
    <div className="h-full overflow-scroll p-8">
      <LabFileBrowser
        path={fileBrowserState.path}
        setPath={(p) => setFileBrowserState({ ...fileBrowserState, path: p })}
        bucketId={fileBrowserState.bucketId ?? undefined}
        setBucketId={(b) => {
          console.log(`Changing bucket to ${b}`);
          setFileBrowserState({ ...fileBrowserState, bucketId: b, path: [] });
        }}
        // initialPath={parent?.split('/') || undefined}
        selection={[]}
        pathType={FileBrowserSelectionType.NONE}
        onSelectionChange={(v, lab) => {}}
      />
    </div>
  );
}
